require('../../vendor/jquery.justifiedGallery.js');

$('.just-gall').justifiedGallery({
    rowHeight: 192,
    fixedHeight: true,
    margins: 5,
    captions: false
});



//////////////////
// WEBPACK FOOTER
// ./js/components/plugins/justified-gal.js
// module id = 7
// module chunks = 0